export default __webpack_public_path__ + "static/media/Winters_Gate_LE.0434ae10.jpg";